import api from "app/api";
import { Options } from "common";

export interface BulkEmailSentItem {
  id: number;
  booking_id: number;
  email_template_id: number | null;
  email: string;
  sent_at: string;
  sent_by_id: number | null;
  sent_by_name: string | null;
  queue_name: string | null;
  error_code: number;
  error_message: string | null;
  created_at: string;
  updated_at: string;
  // List-only fields
  booking_number?: string;
  start_time?: string;
  program_name?: string;
  booking_name?: string;
  template_name?: string;
}

export type BulkEmailSentOptions = Options<"status">;

export function getBulkEmailSentService(scope?: any) {
  return api.getService<
    BulkEmailSentItem,
    BulkEmailSentItem,
    BulkEmailSentOptions
  >("bulk-emails-sent", {
    scope,
  });
}

// Bulk email preview and queue types
export interface BulkEmailPreviewEvent {
  event_id: number;
  program_name: string;
  start_time: string;
  total: number;
  eligible: number;
  skipped: number;
  no_email: number;
  already_sent: number;
}

export interface BulkEmailLimitInfo {
  daily_limit: number;
  sent_today: number;
  pending_in_queue: number;
  remaining: number;
  queue_will_reached: boolean;
}

export interface BulkEmailPreviewResponse {
  success: boolean;
  template_id: number;
  template_name: string;
  summary: {
    total_bookings: number;
    eligible_bookings: number;
    skipped_bookings: number;
    total_events?: number;
  };
  events?: BulkEmailPreviewEvent[];
  limit_info?: BulkEmailLimitInfo;
}

export interface BulkEmailQueueRequest {
  booking_ids?: number[];
  event_ids?: number[];
  template_id: number;
}

export async function previewBulkEmails(
  bookingIds: number[],
  templateId: number,
): Promise<BulkEmailPreviewResponse> {
  const response = await api.post("/bulk-emails/preview", {
    booking_ids: bookingIds,
    template_id: templateId,
  });
  return response.data;
}

export async function previewBulkEmailsByEvent(
  eventIds: number[],
  templateId: number,
): Promise<BulkEmailPreviewResponse> {
  const response = await api.post("/bulk-emails/preview-by-event", {
    event_ids: eventIds,
    template_id: templateId,
  });
  return response.data;
}

export async function queueBulkEmails(
  bookingIds: number[],
  templateId: number,
): Promise<{ success: boolean; message?: string }> {
  const response = await api.post("/bulk-emails/queue", {
    booking_ids: bookingIds,
    template_id: templateId,
  });
  return response.data;
}

export async function queueBulkEmailsByEvent(
  eventIds: number[],
  templateId: number,
): Promise<{ success: boolean; message?: string }> {
  const response = await api.post("/bulk-emails/queue-by-event", {
    event_ids: eventIds,
    template_id: templateId,
  });
  return response.data;
}
